.container {
  overflow: hidden;
  flex: 1;
}

.badge {
  display: block;
  font-size: var(--tuna-typography-fontSize-xs);
  padding: 0 8px;
  position: absolute;
  z-index: 1;
  background-color: var(--tuna-palette-secondary-main);
  color: var(--tuna-palette-primary-contrastText);
}

.canvas {
  width: 100%;
  height: 100%;
}

.layers {
  position: relative;
  width: 100%;
  height: 100%;
}

/* The played part: the same bars in the played colour, clipped to the position (GH #3163) */
.progress {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
